var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 135,
    r: 130,
    stroke: "#D9D9D9",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.191 150.206C129.847 150.206 126.892 147.08 126.323 140.827L120.866 82.5073C120.298 77.5052 121.264 73.4125 123.765 70.2294C126.38 67.0462 130.188 65.4546 135.191 65.4546C140.079 65.4546 143.774 67.0462 146.275 70.2294C148.776 73.4125 149.742 77.5052 149.174 82.5073L143.717 140.827C143.035 147.08 140.193 150.206 135.191 150.206ZM135.191 188.063C130.643 188.063 127.005 186.699 124.277 183.97C121.662 181.242 120.355 177.718 120.355 173.398C120.355 169.192 121.662 165.781 124.277 163.166C127.005 160.438 130.643 159.074 135.191 159.074C139.738 159.074 143.262 160.438 145.763 163.166C148.378 165.781 149.685 169.192 149.685 173.398C149.685 177.718 148.378 181.242 145.763 183.97C143.262 186.699 139.738 188.063 135.191 188.063Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconLarge);
export default __webpack_public_path__ + "static/media/infoIconLarge.95a2f0215d19768d9159560d5c19c33d.svg";
export { ForwardRef as ReactComponent };